/*
 * Post-user.ts
 * Description: Includes the declaration
 * of the function for creating a user
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL, EmailTaken} from '@/ts/variables';

/**
 * Creating a user
 *
 * @return {Object} Promise - when the request has been finished
 * @param {String[]} errors - a list of errors
 * @param {User} data - user data
 */
export function postUser(errors: string[], data) {
    const jwt = localStorage.getItem('jwt');
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'users',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch((error) => {
            // Checking if the field email exists in errors, to prevent errors.
            if (Array.isArray(error.response.data.errors.email)) {
                for (const temp of error.response.data.errors.email) {
                    if (temp === 'The email has already been taken.') {
                        errors.push(EmailTaken);
                    } else {
                        errors.push(temp);
                    }
                }
            }
            // Checking if the field password exists in errors, to prevent errors.
            if (Array.isArray(error.response.data.errors.password)) {
                for (const temp of error.response.data.errors.password) {
                    errors.push(temp);
                }
            }
            reject();
        });
    });
}
